import * as tslib_1 from "tslib";
import Constants from './common/constants';
import Helpers from './common/helpers';
import Setup from './sdk/setup';
var Environment;
(function (Environment) {
    Environment["LOCAL"] = "LOCAL";
    Environment["DEV"] = "DEV";
    Environment["STAGING"] = "STAGING";
    Environment["LIVE"] = "LIVE";
})(Environment || (Environment = {}));
export class FunWalletEmbed {
    /**
     * Lazy load the fun wallet
     * @param setupInfo The setup info
     */
    static load(setupInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const allFunWalletIFrames = Helpers.getAllWalletIFrames();
            const leaders = allFunWalletIFrames.filter((l) => l.attributes.getNamedItem(Constants.isLeaderAttributeName) !== null);
            if (leaders.length === 0) {
                if (!setupInfo.appId) {
                    throw new Error('You must supply an appId');
                }
                const iframe = document.createElement('iframe');
                iframe.allow = 'camera';
                iframe.id = 'funwallet-iframe';
                iframe.setAttribute('is-fun-wallet', 'true');
                iframe.setAttribute('is-leader', 'true');
                const funWalletContainer = document.createElement('div');
                funWalletContainer.classList.add('fun-wallet-container');
                funWalletContainer.append(iframe);
                const funWalletLeader = document.createElement('div');
                funWalletLeader.id = 'fun-wallet-leader';
                funWalletLeader.style.display = 'none';
                funWalletLeader.append(funWalletContainer);
                const funWalletLeaderContainer = document.createElement('div');
                funWalletLeaderContainer.id = 'fun-wallet-leader-container';
                funWalletLeaderContainer.append(funWalletLeader);
                const funWalletDarken = document.createElement('div');
                funWalletDarken.id = 'fun-wallet-darken';
                funWalletLeaderContainer.append(funWalletDarken);
                document.body.prepend(funWalletLeaderContainer);
                const script = document.createElement('script');
                script.src = `https://${FunWalletEmbed.getDomainFromEnv(setupInfo.environment)}/assets/sdk/fun-wallet-sdk.js?appId=${setupInfo.appId}`;
                script.onload = () => {
                    Setup.onload();
                };
                document.getElementsByTagName('head')[0].append(script);
                return new Promise((resolve) => {
                    const interval = setInterval(() => {
                        const leaderIFrameElement = Helpers.getLeaderHTMLIFrameElement();
                        if (leaderIFrameElement.src) {
                            clearInterval(interval);
                            // tslint:disable-next-line: no-any
                            window.funwallet.sdk.init(setupInfo.initOptions);
                            setupInfo.eventListenerCallback();
                            // tslint:disable-next-line: no-any
                            resolve(window.funwallet.sdk);
                        }
                    }, 10);
                });
            }
            else {
                // tslint:disable-next-line: no-any
                return window.funwallet.sdk;
            }
        });
    }
    /**
     * Destroy the injected wallet embedded
     */
    static destroy() {
        const funWalletLeaderContainer = document.getElementById('fun-wallet-leader-container');
        if (funWalletLeaderContainer) {
            funWalletLeaderContainer.remove();
        }
        const scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].src.includes('fun-wallet-sdk.js')) {
                scripts[i].remove();
                break;
            }
        }
        const link = document.getElementsByTagName('link');
        for (let i = 0; i < link.length; i++) {
            if (link[i].href.includes('fun-wallet-sdk.css')) {
                link[i].remove();
                break;
            }
        }
    }
    /**
     * Get the domain per the environment passed in
     * @param environment The environment
     */
    static getDomainFromEnv(environment) {
        switch (environment) {
            case Environment.LOCAL:
                return 'localhost:4200';
            case Environment.DEV:
                return 'dev.wallet.funfair.io';
            case Environment.STAGING:
                return 'staging.wallet.funfair.io';
            case Environment.LIVE:
                return 'wallet.funfair.io';
            default:
                return 'wallet.funfair.io';
        }
    }
}
//# sourceMappingURL=fun-wallet-embed.js.map